module.exports = __webpack_public_path__ + "55bf3880d570feda98932dc935d54b41.png";